import pdfMake from "pdfmake/build/pdfmake";
import { Content, TableCell, TDocumentDefinitions } from "pdfmake/interfaces";
import { helper } from "@/utils/helper";
import { FRONTEND_URL, GetRole } from "@/services";
import { PdfCreation } from "@/utils/pdf-creation/index";
import { LOGO_SVG } from "@/utils/pdf-creation/logo";

pdfMake.fonts = {
  dosis: {
    normal: `${FRONTEND_URL}/fonts/dosis/Dosis-Regular.ttf`,
    bold: `${FRONTEND_URL}/fonts/dosis/Dosis-Bold.ttf`,
  },
};

interface QueryProps {
  user: any;
  roles: any[];
}

export class UserInformationPDFCreation extends PdfCreation {
  query: QueryProps = {
    user: {},
    roles: [],
  };

  options: TDocumentDefinitions = {
    header: {
      margin: [40, 40, 40, 0],
      columns: [
        [
          {
            svg: LOGO_SVG,
            fit: [200, 35],
          },
        ],
        [
          {
            style: "headerLight",
            alignment: "right",
            text: "USER INFORMATION",
          },
          {
            style: "headerLight",
            alignment: "right",
            text: helper.formatDate(new Date(), "DD.MM.YYYY"),
          },
        ],
      ],
    },
    footer: (currentPage, pageCount) => {
      return {
        margin: [40, 10],
        fontSize: 8,
        columns: [
          "Copyright 2021 SMIIC - All rights reserved",
          {
            text: `Page ${currentPage}/${pageCount}`,
            alignment: "right",
          },
        ],
      };
    },
    pageMargins: [40, 80, 40, 30],
    styles: {
      header: {
        fontSize: 13,
        bold: true,
      },
      headerLight: {
        fontSize: 13,
      },
      tableHeader: {
        bold: true,
        fillColor: "#CCCCCC",
      },
    },
    defaultStyle: {
      fontSize: 10,
      lineHeight: 1.2,
      font: "dosis",
    },
    content: [
      {
        margin: [0, 50, 0, 0],
        columns: [
          [
            {
              fontSize: 11,
              text: "{{user.title}}",
            },
            {
              style: "header",
              text: `{{user.salutation}} {{user.name}} {{user.surname}}`,
            },
          ],
          [
            {
              fontSize: 11,
              alignment: "right",
              text: "ADMINISTRATED BY",
            },
            {
              style: "header",
              alignment: "right",
              text: `({{user.administrated_by.acronym}}) {{user.administrated_by.title}}`,
            },
          ],
        ],
      },
      {
        style: "header",
        margin: [0, 15, 0, 5],
        text: "CONTACT INFORMATION",
      },
      {
        text: [
          { text: "Email:  ", bold: true },
          { text: "{{user.email}}", link: "mailto:{{user.email}}" },
        ],
      },
      {
        text: [
          { text: "Phone:  ", bold: true },
          { text: "{{user.phone}}", link: "tel:{{user.phone}}" },
        ],
      },
      {
        text: [{ text: "Address:  ", bold: true }, "{{user.address}}"],
      },
      {
        text: [
          { text: "Country & City:  ", bold: true },
          `{{user.country.title}} & {{user.city}}`,
        ],
      },
      "roles-table",
    ],
  };

  prepareRolesTable(): Array<Content> {
    const roles = _.get(this.query, "roles", []);
    if (roles.length === 0) return [];
    const body: TableCell[][] = [];
    roles.map((role: GetRole) => {
      let title = role.title;
      if (role.ballot_types.length > 0)
        title += ` (${role.ballot_types.join(", ")})`;
      body.push([
        title,
        `${_.get(role, "scope.acronym", "")} ${_.get(role, "scope.title", "")}`,
      ]);
    });
    return [
      {
        style: "header",
        margin: [0, 15, 0, 5],
        text: "ROLES",
      },
      {
        table: {
          headerRows: 1,
          // dontBreakRows: true,
          keepWithHeaderRows: 1,
          widths: ["*", "*"],
          body: [
            [
              { text: "Title", style: "tableHeader" },
              { text: "Resource", style: "tableHeader" },
            ],
            ...body,
          ],
        },
        layout: {
          hLineColor: "#999999",
          vLineColor: "#999999",
        },
      },
    ];
  }

  replaceLines(lines: Array<Content>): Array<Content> {
    return super.replaceLines(lines).map((line) => {
      if (line === "roles-table") {
        line = this.prepareRolesTable();
      }
      return line;
    });
  }

  prepareCoverPages(): Promise<any> {
    return new Promise((resolve) => {
      const content = this.replaceLines(
        _.cloneDeep(this.options.content) as Array<Content>
      );
      const pdfDoc = pdfMake.createPdf({ ...this.options, content });
      pdfDoc.getBuffer((result) => resolve(result));
    });
  }
}
